import { ReactNode } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { NavMenuNames, NavMenuNamesForEvent, MainNavChildObjectType } from "src/types";
export default function MainNavBtns(props: {
  childDataObject: MainNavChildObjectType;
  showingChildNames?: (NavMenuNames | NavMenuNamesForEvent)[];
  currentMemberLevel?: number;
  activeMenu?: NavMenuNames | NavMenuNamesForEvent;
}) {
  const navigate = useNavigate();
  const childDataObject = props?.childDataObject;

  if (!props.showingChildNames?.length) {
    return <></>;
  }

  return (
    <MainContainer className="mt-2 d-flex fd-c jc-e gap-2">
      <div className="nav-buttons">
        {(() => {
          const buttons = props.showingChildNames?.map((c, idx) => {
            const d = childDataObject[c];
            const hadRestriction = Boolean(d?.accessAllowedLevels?.length);
            const isAllowed = d?.accessAllowedLevels?.includes(props.currentMemberLevel || 0);
            return (
              <Child
                disabled={hadRestriction && !isAllowed}
                key={`${d?.name}-${idx}`}
                name={d?.name}
                size={d?.size}
                icon={d?.icon}
                img={d?.img}
                isActive={c === props.activeMenu}
                onClick={() => {
                  if (d?.isNav && d?.navPath) {
                    navigate(d?.navPath);
                  }
                }}
              />
            );
          });

          // Group buttons into rows of 2
          const rows = [];
          for (let i = 0; i < buttons.length; i += 2) {
            rows.push(
              <div key={`row-${i}`} className="nav-button-row">
                {buttons.slice(i, i + 2)}
              </div>
            );
          }

          return rows;
        })()}
      </div>
    </MainContainer>
  );
}

const MainContainer = styled.div`
  h3 {
    font-weight: bold;
    font-size: 18px;
  }

  .menu-name {
    white-space: nowrap;
  }

  .nav-buttons {
    padding: 4px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .nav-button-row {
    display: flex;
    gap: 8px;
  }

  .nav-button {
    flex: 1;
    height: 50px;
    padding: 16px;
    border: 1px solid #d1d5d8;
    border-radius: 6px;
    background: #fdfdfd;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .nav-button:hover {
    background: #f0f0f4;
  }

  .nav-button.active {
    background: white;
    border: 1px solid #0066ff;
    box-shadow: 0 2px 8px rgba(0, 102, 255, 0.15);
    transform: translateY(-1px);
  }

  .nav-button.active:hover {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 102, 255, 0.2);
  }

  .nav-button.active span {
    color: #0066ff;
    font-weight: 700;
  }

  .nav-button.active img {
    filter: brightness(0) saturate(100%) invert(27%) sepia(99%) saturate(2843%) hue-rotate(208deg)
      brightness(102%) contrast(105%);
  }

  .nav-button span {
    color: #79818a;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }
`;

function Child(props: {
  name: ReactNode;
  icon: ReactNode;
  onClick?: () => any;
  size?: 3 | 4 | 5;
  disabled?: boolean;
  img?: string;
  isActive?: boolean;
}) {
  return (
    <button
      className={`nav-button ${props.isActive ? "active" : ""}`}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.img ? (
        <img
          src={props.img}
          alt=""
          style={{ width: "24px", height: "16px", objectFit: "contain" }}
        />
      ) : (
        props.icon
      )}
      <span>{props.name}</span>
    </button>
  );
}
